import DACurrentActionModel from '../../../models/actions/DACurrentActionModel';

const state = () => ({
    currentAction: new DACurrentActionModel(),
})

export default state